// extracted by mini-css-extract-plugin
export default {"root":"Favorites_root__E7Ly8","flex":"Favorites_flex__6rExf","main":"Favorites_main__--zlB","info":"Favorites_info__bsBmZ","price":"Favorites_price__LcErh"};